// extracted by mini-css-extract-plugin
export default {"center":"center__uButton___Pp2hn9IwNb","transition-all":"transition-all__uButton___RvI9sQ0gtA","main":"main__uButton___w7kF0rLPuN"};